// Imported by main BEFORE the router. Window hashchange listeners run in
// registration order; a component's later capture listener cannot veto routing.
let guard = null;

if (typeof window !== 'undefined') {
  let acceptedHash = window.location.hash;
  window.addEventListener('hashchange', event => {
    if (guard && !guard()) {
      event.stopImmediatePropagation();
      history.replaceState(history.state, '', `${location.pathname}${location.search}${acceptedHash}`);
      return;
    }
    acceptedHash = window.location.hash;
  });
}

export function registerNavigationGuard(check) {
  guard = check;
  return () => { if (guard === check) guard = null; };
}
